
import { Divider } from "antd";
import "../../Styles/Web.css"
import { WidgetsReviews } from "./widgets/WidgetsReviews"

export const WebReviews = ({id, title, color}) => {

    return (
        <div className="block" id="testimonios" style={{background:`ghostwhite`}}>
            <h1 className='block-title'>{title}</h1>
            <div style={{borderRadius:'10px', height:'6px', width: '250px', margin:'10px', background:`linear-gradient(to right, transparent, ${color})`}}/>                
            <WidgetsReviews id={id}/>
        </div>
    )
}
